module.exports = __webpack_public_path__ + "./Zoe_pbw_98413997145a4fc550d531e97b779c67.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Zoe_pbw.png
// module id = 611
// module chunks = 0